<template>
  <pool title="学历" @chooseCount="chooseCount" :dataList="showDataList" :countList="countList" v-loading="loading"></pool>
</template>

<script>
import {
  loadDetail,
  detailFilter,
  getCountData
} from './lib'

import pool from './pool'
export default {
  data () {
    return {
      dataList: [],
      searchParm: {
        education: null
      },
      loading: false
    }
  },
  components: {
    pool
  },
  computed: {
    typeList () {
      return this.$store.getters.selectDatas['worker_education_list'].map(v => {
        return {
          name: v.label
        }
      })
    },
    showDataList () {
      return this.dataList.filter(v => detailFilter(v, this.searchParm))
    },
    countList () {
      let data = getCountData(this.dataList, this.typeList, 'education', '无学历')
      data.forEach(v => v.active = this.searchParm.education === v.key)
      return data
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    chooseCount (cIndex) {
      let education = this.countList[cIndex].key
      if (this.searchParm.education === education) {
        this.searchParm.education = null
      } else {
        this.searchParm.education = education
      }
    },
    async loadData () {
      this.loading = true
      this.dataList = await loadDetail(this)
      this.loading = false
    }
  }
}
</script>
